import React, { useEffect } from 'react';
import { downloadDispatchNote } from 'app/api/dispatchNoteApi';

const PersonTable: React.FC = () => {
  useEffect(() => {
    // generateDispatchNote();
    downloadDispatchNote(13);
  }, []);

  return <div>test generate</div>;
};

export default PersonTable;
